module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "feris.4421760a.png";